var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accessories-price"},[_c('h3',[_vm._v(_vm._s(_vm.translate('accessories_in_price')))]),_c('ul',_vm._l((_vm.accessories),function(element){return _c('li',{staticClass:"included-list-products"},[_c('span',{staticClass:"icon-ok"}),_c('span',{staticClass:"product-tilte"},[_vm._v(_vm._s(_vm.translate(element.title)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }